import * as React from "react";
import { QueryClientProvider } from "react-query";
import { ChakraProvider, ColorModeScript, CSSReset } from "@chakra-ui/react";
import { theme } from "./theme";
import Routes from "./routes";
import { queryClient } from "./libs/react-query";
import Plugins from "./plugins";
import "react-widgets/styles.css";

export default function App() {
  return (
    <>
      <CSSReset />
      <ChakraProvider theme={theme}>
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <QueryClientProvider client={queryClient}>
          <Plugins>
            <Routes />
          </Plugins>
        </QueryClientProvider>
      </ChakraProvider>
    </>
  );
}
